import GSAP from 'gsap'
import Animation from 'classes/Animation'
import { times } from 'lodash'

export default class ImgHover extends Animation {
  constructor({ element, elements }) {
    super({
      element,
      elements
    })

    this.general = {
      header: document.querySelector('.menu_list'),
      footer: document.querySelector('.footer_menu_list')
    }

    this.links = {
      header: document.querySelectorAll('.menu_list_item_link'),
      footer: document.querySelectorAll('.footer_menu_list_item')
    }

    this.image = {
      header: document.querySelector('.menu_images_page_image'),
      footer: document.querySelector('.footer_images_page_image'),
      defaultHeader: document.querySelector('.menu_images_page_image_default'),
      defaultFooter: document.querySelector('.footer_images_page_image_default')
    }

    this.images = {
      header: document.querySelectorAll('.menu_images_page_image'),
      footer: document.querySelectorAll('.footer_images_page_image')
    }

    this.elementDataSrc = this.element.getAttribute('data-src')

    this.imagesrc = this.elementDataSrc
    this.linksrc = null
    this.tl = GSAP.timeline()

    this.onLoad()
  }

  onLoad() {

    this.images.header.forEach(img => {
      GSAP.set(img, {
        autoAlpha: 0
      })
    })

    this.images.footer.forEach(img => {
      GSAP.set(img, {
        autoAlpha: 0
      })
    });
  }

  animateIn() {
    this.createInteractions()
  }

  changeImage = (currentImg) => {
    this.tl.clear()

    this.tl.to(this.image.defaultHeader, {
      autoAlpha: 0,
      duration: 1,
      ease: 'power4.inOut'
    }).to(currentImg, {
      autoAlpha: 1,
      duration: 1,
      ease: 'power4.inOut'
    }, '>')

    this.tl.restart()

    this.general.header.addEventListener('mouseleave', () => {
      this.tl.to(this.image.defaultHeader, {
        autoAlpha: 1,
        duration: 0.5,
        transformOrigin: 'center bottom',
        ease: 'power4.out'
      })
    })
  }

  changeBack = (prevImg) => {
    this.tl.clear()

    GSAP.fromTo(prevImg, {
      autoAlpha: 1,
      // y: '0',
      duration: 1,
      ease: 'power4.out'
    }, {
      autoAlpha: 0,
      // y: '60px',
      duration: 1,
      ease: 'power4.out'
    }).restart()

  }

  changeImageFooter = (currentImgFooter) => {
    this.tl.clear()

    this.tl.to(this.image.defaultFooter, {
      autoAlpha: 0,
      duration: 1,
      ease: 'power4.out'
    }, '>').to(currentImgFooter, {
      autoAlpha: 1,
      duration: 1,
      ease: 'power4.out'
    }, '>')

    this.tl.restart()

    this.general.footer.addEventListener('mouseleave', () => {
      GSAP.to(this.image.defaultFooter, {
        autoAlpha: 1,
        y: '0',
        duration: 1,
        ease: 'power4.out'
      })
    })
  }

  changeBackFooter = (prevImg) => {
    this.tl.clear()

    GSAP.fromTo(prevImg, {
      autoAlpha: 1,
      duration: 2,
      ease: 'power4.out'
    }, {
      autoAlpha: 0,
      duration: 2,
      ease: 'power4.out'
    }).restart()

  }

  animateOut() {
    this.removeInteractions()
  }

  createInteractions = () => {

    // HEADER

    for (let link of this.links.header) {
      link.addEventListener('mouseenter', (currentImg) => {
        let img = this.images.header[link.dataset.item]
        currentImg = img

        this.changeImage(currentImg)
      })

      link.addEventListener('mouseleave', (prevImg) => {
        let img = this.images.header[link.dataset.item]
        prevImg = img

        this.changeBack(prevImg)
      })
    }

    // FOOTER

    for (let link of this.links.footer) {
      link.addEventListener('mouseenter', (currentImgFooter) => {
        let img = this.images.footer[link.dataset.item]
        currentImgFooter = img

        this.changeImageFooter(currentImgFooter)
      })

      link.addEventListener('mouseleave', (prevImg) => {
        let img = this.images.footer[link.dataset.item]
        prevImg = img

        this.changeBackFooter(prevImg)
      })
    }
  }

  removeInteractions = () => {
    for (let link of this.links.header) {
      link.removeEventListener('mouseenter', (currentImg) => {
        let img = this.images.header[link.dataset.item]
        currentImg = img

        this.changeImage(currentImg)
      })

      link.removeEventListener('mouseleave', (prevImg) => {
        let img = this.images.header[link.dataset.item]
        prevImg = img

        this.changeBack(prevImg)
      })
    }
  }
}
